<template>
  <div class="item-to-role-container">
    <!-- 新增：展示当前查询时间（可选，提升体验） -->
    <div class="date-info" v-if="props.selectedDate">
      <span class="date-label">当前查询日期：</span>
      <span class="date-value">{{ props.selectedDate }}</span>
    </div>

    <!-- 1. 物品名称 + 角色名称 双输入表单（原有内容） -->
    <div class="search-form">
      <el-input
        v-model="itemName"
        placeholder="请输入物品名称（如：屠龙刀、魔法盾）"
        class="form-input"
        clearable
        style="margin-right: 10px"
      />
      <el-input
        v-model="selectedRoleName"
        placeholder="请输入角色名称"
        class="form-input"
        clearable
        style="margin-right: 10px"
      />
      <el-button type="primary" size="small" @click="loadRoleItemDetail" :disabled="!itemName.trim() || !selectedRoleName.trim()">
        查询物品详情
      </el-button>
    </div>

    <!-- 3. 物品详情表格（原有内容） -->
    <div class="item-detail-wrapper">
      <table class="item-detail-table">
        <thead>
          <tr>
            <th>物品名称</th>
            <th>物品来源</th>
            <th>物品介绍</th>
            <th>物品数量</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="roleItemDetail.length === 0">
            <td colspan="4" class="empty-cell">未找到匹配的数据</td>
          </tr>
          <tr v-for="(item, index) in roleItemDetail" :key="index">
            <td>{{ item.itemname }}</td>
            <td>{{ item.Dec }}</td>
            <td>{{ item.username || '无相关信息' }}</td>
            <td>{{ item.count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { LOG_API } from '@/utils/apiBase';
import { ref, watch } from 'vue'; // 新增：引入watch
import { ElMessage } from 'element-plus';
import axios from 'axios';

// 1. 核心修改：在Props中新增selectedDate参数（必加）
const props = defineProps({
  serverId: {
    type: String,
    required: true
  },
  selectedDate: { // 新增：接收父组件的时间参数
    type: String,
    default: '' // 默认为空，表示查询全部时间
  }
});

// 响应式数据（原有内容不变）
const itemName = ref('');
const selectedRoleName = ref('');
const roleItemDetail = ref([]);

// 2. 原有方法：已使用props.selectedDate，无需修改（仅确认）
const loadRoleItemDetail = async () => {
  if (!selectedRoleName.value || !itemName.value.trim()) {
    roleItemDetail.value = [];
    ElMessage.warning('请完整输入物品名称和角色名称');
    return;
  }

  try {
    const res = await axios.get(`${LOG_API}/api/drop/GetitemsAdd`, {
      params: { 
        serverId: props.serverId,    
        itemName: itemName.value.trim(),
        userName: selectedRoleName.value,
        time: props.selectedDate ? props.selectedDate : '所有' // 已存在，无需修改
      },
      timeout: 10000
    });
    console.log('GetitemsAdd接口：',props.serverId,itemName.value.trim(),selectedRoleName.value,props.selectedDate ? props.selectedDate : '所有');
    console.log('GetitemsAdd接口返回：', res.data);
    const responseData = res.data;
    
    if (responseData.code === 200) {
      roleItemDetail.value = responseData.data || [];
      if (roleItemDetail.value.length === 0) {
        ElMessage.info('未查询到该角色的该物品相关信息');
      }
    } else {
      ElMessage.warning(responseData.msg || '查询物品详情失败');
      roleItemDetail.value = [];
    }
  } catch (err) {
    console.error('调用GetitemsAdd接口失败:', err);
    roleItemDetail.value = [];
    ElMessage.error('查询物品详情失败，请检查接口连接');
  }
};

// 3. 核心修改：监听时间变化，提示用户或自动刷新（必加）
watch(
  () => props.selectedDate, // 监听父组件传递的时间参数
  (newDate, oldDate) => {
    if (newDate !== oldDate) {
      // 提示用户日期已切换
      ElMessage.info(`查询日期已更新为：${newDate || '全部日期'}`);
      
      // 可选：若已有输入内容，自动重新查询（提升体验）
      if (itemName.value.trim() && selectedRoleName.value.trim()) {
        loadRoleItemDetail(); // 自动重新查询
      }
    }
  },
  { immediate: false }
);

</script>

<style scoped>
/* 新增：日期信息展示样式 */
.date-info {
  margin-bottom: 12px;
  padding: 6px 10px;
  background-color: #2d2d44;
  border-radius: 4px;
  display: inline-block;
}
.date-label {
  color: #ccc;
  font-size: 12px;
}
.date-value {
  color: #3a7bd5;
  font-weight: 500;
  font-size: 12px;
  margin-left: 4px;
}

/* 原有样式不变 */
.item-to-role-container {
  padding: 16px;
  color: #fff;
  background-color: #1e293b;
  border-radius: 8px;
}
.search-form {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
  flex-wrap: wrap;
}
.form-input {
  flex: 1;
  min-width: 200px;
  --el-input-bg-color: #2d2d44;
  --el-input-border-color: #3d3d5c;
  --el-input-text-color: #fff;
  --el-input-placeholder-color: #888;
}
.item-detail-wrapper {
  width: 100%;
}
.item-detail-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #2d2d44;
  border-radius: 4px;
  overflow: hidden;
}
.item-detail-table th {
  background-color: #3d3d5c;
  padding: 8px 12px;
  text-align: left;
  color: #ccc;
  border-bottom: 1px solid #3d3d5c;
}
.item-detail-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #3d3d5c;
  color: #e0e0e0;
}
.empty-cell {
  text-align: center;
  color: #888;
  padding: 20px 0;
}
</style>